import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { SlideupDirective } from '../../../directives/animations/slideup.directive';
import { Product, ProductCollections } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { ProductListItem } from '../../product/product-list-item/product-list-item';

@Component({
  selector: 'section[app-home-best-sellers]',
  imports: [
    MatProgressSpinnerModule,
    ProductListItem,
    RouterModule,
    SlideupDirective,
  ],
  templateUrl: './home-best-sellers.html',
  styleUrl: './home-best-sellers.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeBestSellers implements OnInit {
  loading: boolean = false;
  products: Product[] = [];
  constructor(private productApi: ProductApiService) {}

  ngOnInit(): void {
    this.findProducts();
  }

  get collectionNo(): string {
    return ProductCollections.BestSellers;
  }

  async findProducts() {
    try {
      this.loading = true;
      const r = await this.productApi.findProductCollectionProducts(
        this.collectionNo,
        { page: 1, page_size: 20 }
      );
      this.products = r.items.reverse();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
